module.exports = __webpack_public_path__ + "static/img/hy4.dd7de1fc.png";